module.exports = __webpack_public_path__ + "img/emoji3.7bcbfd65.svg";